import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 18.999 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.999 19\" id=\"icon-search\">\r\n  <path d=\"M18,19a.991.991,0,0,1-.707-.293l-5.244-5.243A7.432,7.432,0,0,1,7.5,15,7.5,7.5,0,1,1,15,7.5a7.429,7.429,0,0,1-1.538,4.55l5.244,5.243A1,1,0,0,1,18,19ZM7.5,2A5.5,5.5,0,1,0,13,7.5,5.506,5.506,0,0,0,7.5,2Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol